'use client'

import { ComponentProps } from 'react'

import { TRoomDetail } from '@/entities/room'

import { ActionButtons } from './action-buttons'
import { ContractButton } from './contract-button'
import * as Contract from './contract-information'
import { DiscountInformation } from './discount-information'
import { RoomInformation } from './room-information'

type Props = ComponentProps<'div'> & {
  room: Pick<
    TRoomDetail,
    | 'rid'
    | 'roomUrl'
    | 'like'
    | 'usingFee'
    | 'mgmtFee'
    | 'minimumContractWeeks'
    | 'longTermDiscounts'
    | 'earlyCheckinDiscounts'
  >
  pageType?: 'detail' | 'preview' | 'contract'
}

export const SidePanel = ({
  room,
  pageType = 'detail',
  ref,
  ...props
}: Props) => {
  const showLikeButton = pageType === 'detail'
  const isContractDisabled = pageType !== 'detail'

  return (
    <div
      className="h-fit w-[330px] rounded-sm bg-white pt-4 pb-10 shadow-[0px_1px_7px_0px_rgba(0,0,0,0.15)]"
      ref={ref}
      {...props}
    >
      <ActionButtons
        roomId={room.rid}
        like={room.like}
        showLikeButton={showLikeButton}
        roomUrl={room.roomUrl}
      />
      <RoomInformation
        usingFee={room.usingFee}
        mgmtFee={room.mgmtFee}
        minimumContractWeeks={room.minimumContractWeeks}
      />
      <DiscountInformation
        longTermDiscounts={room.longTermDiscounts}
        earlyCheckinDiscounts={room.earlyCheckinDiscounts}
      />
      <Contract.Provider roomId={room.rid}>
        <Contract.Container>
          <Contract.PeriodButton />
          <Contract.PriceInformation roomId={room.rid} />
        </Contract.Container>
        <ContractButton roomId={room.rid} disabled={isContractDisabled} />
      </Contract.Provider>
    </div>
  )
}
